import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    try {
      const token = localStorage.getItem('jwtToken');
      const currentPath = location.pathname;

      const isAuthPage = currentPath === '/signin' || currentPath === '/signup';

      if (!token && !isAuthPage) {
        navigate('/signin', { replace: true });
      } else if (token && isAuthPage) {
        navigate('/', { replace: true });
      }
    } catch (error) {
      console.error('Auth redirect error:', error);
    }
  }, [navigate, location.pathname]);
};

export default useAuthRedirect;
